<template>
	<a :href="itemLink" :target="itemTarget" class="card article-card h-full bg-cover" :style="mediaStyle" v-waves.block.light>
	  	<div class="card-media">
		  	<div class="card-content">
		  		<h4 class="card-title">{{ item.title }}</h4>
		  		<div class="card-info">
		  			<img class="avatar" v-if="item.author && item.author.preview" :src="item.author.poster_image">
			  		<div class="card-info-items">
				  		<span class="card-info-item" v-if="item.author">
				  			{{ item.author.name }}
							</span>
				  		<span class="card-info-item ">
				  			<!-- {{ item.published_at_month_day }} -->
							</span>
				  	</div>
		  		</div>
		  	</div>
	  	</div>
	</a>
</template>

<script>
    import ListItem from '../mixins/base-list-item';

    export default{
        mixins: [ListItem],

        computed: {
            itemLink() {
            	if(this.item.link) {
            		return this.item.link;
				}
                return '/articles/' + this.item.slug;
            },

			itemTarget() {
            	if(this.item.link) {
            		return '_blank';
				}

            	return '_self';
			},

            mediaStyle() {
            	if(!this.item.poster_image) {
	            	return '';
	            }

	            return 'background-image:url('+this.item.poster_image+');';
            }
        }
    }
</script>
